export default __webpack_public_path__ + "static/media/Brianna 9781408363188.4cb62516.jpg";